/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { validatePresence } from "ember-changeset-validations/validators";
import type { ValidatorMap } from "ember-changeset/types";
import BaseMedicalHistoryFormComponent from "parog-web/components/medical-history/abstract/base-edition-form";
import MedicalHistoryBaseEditionForm from "../base-edition-form";

export default class MentalwiseMedicalHistoryEditionForm extends BaseMedicalHistoryFormComponent {
  MedicalHistoryBaseEditionForm = MedicalHistoryBaseEditionForm;

  get patho(): string | undefined {
    return this.args.patient.followUpReasonRecord?.patho;
  }

  static fullComponentId = "medical-history/edition";

  retrieveJournalEvent = () =>
    this.args.patient.medicalHistoryChangedJournalEvent;

  depressionPathologyProperties = [
    "numberOfTs",
    "suicideRisk",
    "suicidalThoughtsStartDate"
  ];

  journalEventProperties = [
    "mainDiagnosis",
    ...this.sharedProperties,
    ...this.depressionPathologyProperties
  ];

  get validations(): ValidatorMap {
    const validations = {
      mainDiagnosis: validatePresence({
        presence: true,
        description: "Le diagnostic principal"
      })
    };

    if (this.patho === "depression")
      validations["suicideRisk"] = validatePresence({
        presence: true,
        description: "Le risque suicidaire"
      });

    return validations;
  }
}
